let bank = [
    { "code": "455", "name": "AIA생명" },
    { "code": "405", "name": "AIG손해보험" },
    { "code": "302", "name": "BNK캐피탈" },
    { "code": "224", "name": "BNK투자증권" },
    { "code": "404", "name": "BNP파리바 카디프생명" },
    { "code": "060", "name": "BOA은행" },
    { "code": "361", "name": "BC카드" },
    { "code": "279", "name": "DB금융투자" },
    { "code": "457", "name": "DB생명보험" },
    { "code": "443", "name": "DB손해보험" },
    { "code": "274", "name": "DS투자증권" },
    { "code": "054", "name": "HSBC은행" },
    { "code": "225", "name": "IBK투자증권" },
    { "code": "305", "name": "JB우리캐피탈" },
    { "code": "458", "name": "KDB생명보험" },
    { "code": "450", "name": "KB라이프" },
    { "code": "444", "name": "KB손해보험" },
    { "code": "218", "name": "KB증권" },
    { "code": "308", "name": "KB캐피탈" },
    { "code": "371", "name": "NH농협카드" },
    { "code": "440", "name": "NH농협생명" },
    { "code": "449", "name": "NH농협손해보험" },
    { "code": "011", "name": "NH농협은행" },
    { "code": "306", "name": "NH농협캐피탈" },
    { "code": "247", "name": "NH투자증권" },
    { "code": "272", "name": "NH선물" },
    { "code": "023", "name": "SC제일은행" },
    { "code": "266", "name": "SK증권" },
    { "code": "039", "name": "경남은행" },
    { "code": "034", "name": "광주은행" },
    { "code": "364", "name": "광주카드" },
    { "code": "433", "name": "교보라이프플래닛생명" },
    { "code": "436", "name": "교보생명" },
    { "code": "261", "name": "교보증권" },
    { "code": "066", "name": "교통은행" },
    { "code": "004", "name": "국민은행" },
    { "code": "381", "name": "국민카드" },
    { "code": "003", "name": "기업은행" },
    { "code": "077", "name": "기술보증기금" },
    { "code": "012", "name": "농축협" },
    { "code": "227", "name": "다올투자증권" },
    { "code": "267", "name": "대신증권" },
    { "code": "065", "name": "대화은행" },
    { "code": "055", "name": "도이치은행" },
    { "code": "402", "name": "동양생명" },
    { "code": "435", "name": "라이나생명" },
    { "code": "223", "name": "리딩투자증권" },
    { "code": "445", "name": "롯데손해보험" },
    { "code": "368", "name": "롯데카드" },
    { "code": "303", "name": "롯데캐피탈" },
    { "code": "287", "name": "메리츠증권" },
    { "code": "448", "name": "메리츠화재" },
    { "code": "052", "name": "모간스탠리은행" },
    { "code": "431", "name": "미래에셋생명" },
    { "code": "238", "name": "미래에셋증권" },
    { "code": "311", "name": "미래에셋캐피탈" },
    { "code": "058", "name": "미즈호은행" },
    { "code": "032", "name": "부산은행" },
    { "code": "290", "name": "부국증권" },
    { "code": "061", "name": "비엔피파리바은행" },
    { "code": "452", "name": "삼성생명" },
    { "code": "240", "name": "삼성증권" },
    { "code": "365", "name": "삼성카드" },
    { "code": "211", "name": "삼성선물" },
    { "code": "441", "name": "삼성화재" },
    { "code": "221", "name": "상상인증권" },
    { "code": "064", "name": "산림조합중앙회" },
    { "code": "002", "name": "산업은행" },
    { "code": "045", "name": "새마을금고" },
    { "code": "094", "name": "서울보증보험" },
    { "code": "007", "name": "수협은행" },
    { "code": "369", "name": "수협카드" },
    { "code": "008", "name": "수출입은행" },
    { "code": "438", "name": "신한라이프생명보험" },
    { "code": "088", "name": "신한은행" },
    { "code": "366", "name": "신한카드" },
    { "code": "278", "name": "신한투자증권" },
    { "code": "291", "name": "신영증권" },
    { "code": "048", "name": "신협" },
    { "code": "076", "name": "신용보증기금" },
    { "code": "370", "name": "씨티카드" },
    { "code": "277", "name": "에스아이증권" },
    { "code": "213", "name": "에셋플러스자산운용" },
    { "code": "437", "name": "에이비엘생명" },
    { "code": "459", "name": "에이스아메리칸화재해상보험" },
    { "code": "307", "name": "애큐온캐피탈" },
    { "code": "447", "name": "악사손해보험" },
    { "code": "059", "name": "엠유에프지은행" },
    { "code": "265", "name": "엘에스증권" },
    { "code": "312", "name": "오케이캐피탈" },
    { "code": "071", "name": "우체국" },
    { "code": "020", "name": "우리은행" },
    { "code": "295", "name": "우리종합금융" },
    { "code": "041", "name": "우리카드" },
    { "code": "299", "name": "우리금융캐피탈" },
    { "code": "209", "name": "유안타증권" },
    { "code": "280", "name": "유진투자증권" },
    { "code": "212", "name": "유진투자선물" },
    { "code": "276", "name": "유화증권" },
    { "code": "152", "name": "인도네시아느가라은행" },
    { "code": "031", "name": "아이엠뱅크(구 대구은행)" },
    { "code": "456", "name": "아이엠라이프생명보험" },
    { "code": "301", "name": "아이엠캐피탈" },
    { "code": "050", "name": "저축은행" },
    { "code": "037", "name": "전북은행" },
    { "code": "372", "name": "전북카드" },
    { "code": "035", "name": "제주은행" },
    { "code": "373", "name": "제주카드" },
    { "code": "057", "name": "제이피모간체이스은행" },
    { "code": "067", "name": "중국건설은행" },
    { "code": "062", "name": "중국공상은행" },
    { "code": "063", "name": "중국은행" },
    { "code": "460", "name": "처브라이프생명보험" },
    { "code": "090", "name": "카카오뱅크" },
    { "code": "288", "name": "카카오페이증권" },
    { "code": "089", "name": "케이뱅크" },
    { "code": "214", "name": "케이씨지아이자산운용" },
    { "code": "292", "name": "케이프투자증권" },
    { "code": "273", "name": "코리아에셋투자증권" },
    { "code": "264", "name": "키움증권" },
    { "code": "092", "name": "토스뱅크" },
    { "code": "271", "name": "토스증권" },
    { "code": "434", "name": "푸본현대생명" },
    { "code": "401", "name": "하나생명보험" },
    { "code": "406", "name": "하나손해보험" },
    { "code": "081", "name": "하나은행" },
    { "code": "270", "name": "하나증권" },
    { "code": "374", "name": "하나카드" },
    { "code": "310", "name": "하나캐피탈" },
    { "code": "001", "name": "한국은행" },
    { "code": "309", "name": "한국캐피탈" },
    { "code": "027", "name": "한국씨티은행" },
    { "code": "101", "name": "한국신용정보원" },
    { "code": "494", "name": "한국자산관리공사" },
    { "code": "293", "name": "한국증권금융" },
    { "code": "243", "name": "한국투자증권" },
    { "code": "313", "name": "한국투자캐피탈" },
    { "code": "294", "name": "한국포스증권" },
    { "code": "432", "name": "한화생명" },
    { "code": "454", "name": "한화손해보험" },
    { "code": "215", "name": "한화자산운용" },
    { "code": "269", "name": "한화투자증권" },
    { "code": "222", "name": "한양증권" },
    { "code": "262", "name": "하이투자증권" },
    { "code": "367", "name": "현대카드" },
    { "code": "304", "name": "현대캐피탈" },
    { "code": "442", "name": "현대해상" },
    { "code": "263", "name": "현대차증권" },
    { "code": "453", "name": "흥국생명" },
    { "code": "275", "name": "흥국증권" },
    { "code": "403", "name": "흥국화재" }
]


let bank1 = [
    { id: "1", name: "KEB 하나은행" },
    { id: "2", name: "SC은행" },
    { id: "3", name: "경남은행" },
    { id: "4", name: "광주은행" },
    { id: "5", name: "교보증권" },
    { id: "6", name: "국민은행" },
    { id: "7", name: "굿모닝신한증권" },
    { id: "8", name: "기업은행" },
    { id: "9", name: "기타외국은행" },
    { id: "10", name: "농협중앙회" },
    { id: "11", name: "농협지역" },
    { id: "12", name: "대구은행" },
    { id: "13", name: "대신증권" },
    { id: "14", name: "대우증권" },
    { id: "15", name: "도이치은행" },
    { id: "16", name: "도쿄미쓰비시은행" },
    { id: "17", name: "동부증권" },
    { id: "18", name: "메리츠증권" },
    { id: "19", name: "모간스탠리" },
    { id: "20", name: "미래에셋증권" },
    { id: "21", name: "미즈호코퍼레이트은행" },
    { id: "22", name: "뱅크오브아메리카" },
    { id: "23", name: "부국증권" },
    { id: "24", name: "부산은행" },
    { id: "25", name: "산림조합" },
    { id: "26", name: "삼성증권" },
    { id: "27", name: "상호저축은행" },
    { id: "28", name: "새마을금고" },
    { id: "29", name: "솔로몬투자증권" },
    { id: "30", name: "수협은행" },
    { id: "31", name: "신영증권" },
    { id: "32", name: "신한은행" },
    { id: "33", name: "신협" },
    { id: "34", name: "에스케이증권" },
    { id: "35", name: "에이비엔암로은행" },
    { id: "36", name: "에이치엠씨투자증권" },
    { id: "37", name: "엔에이치투자증권" },
    { id: "38", name: "엘아이지투자증권" },
    { id: "39", name: "우리은행" },
    { id: "40", name: "우리투자증권" },
    { id: "41", name: "우체국" },
    { id: "42", name: "웰컴저축은행" },
    { id: "43", name: "유안타증권" },
    { id: "44", name: "유진투자증권" },
    { id: "45", name: "이트레이드증권" },
    { id: "46", name: "전북은행" },
    { id: "47", name: "제주은행" },
    { id: "48", name: "카카오뱅크" },
    { id: "49", name: "카카오페이증권" },
    { id: "50", name: "케이뱅크" },
    { id: "51", name: "키움증권" },
    { id: "52", name: "토스뱅크" },
    { id: "53", name: "하나대투증권" },
    { id: "54", name: "하이투자증권" },
    { id: "55", name: "한국산업은행" },
    { id: "56", name: "한국씨티은행" },
    { id: "57", name: "한국투자증권" },
    { id: "58", name: "한화증권" },
    { id: "59", name: "현대증권" },
    { id: "60", name: "홍콩상하이은행" },
    { id: "61", name: "외환은행" }
];

let bank2 = [
    {
        "code": "224",
        "name": "BNK투자증권"
    },
    {
        "code": "60",
        "name": "BOA은행"
    },
    {
        "code": "279",
        "name": "DB금융투자"
    },
    {
        "code": "263",
        "name": "HMC투자증권"
    },
    {
        "code": "54",
        "name": "HSBC은행"
    },
    {
        "code": "225",
        "name": "IBK투자증권"
    },
    {
        "code": "226",
        "name": "KB투자증권"
    },
    {
        "code": "81",
        "name": "KEB하나은행"
    },
    {
        "code": "227",
        "name": "KTB투자증권"
    },
    {
        "code": "289",
        "name": "NH투자증권"
    },
    {
        "code": "23",
        "name": "SC은행"
    },
    {
        "code": "266",
        "name": "SK증권"
    },
    {
        "code": "39",
        "name": "경남은행"
    },
    {
        "code": "95",
        "name": "경찰청"
    },
    {
        "code": "221",
        "name": "골든브릿지투자증권"
    },
    {
        "code": "34",
        "name": "광주은행"
    },
    {
        "code": "261",
        "name": "교보증권"
    },
    {
        "code": "66",
        "name": "교통은행"
    },
    {
        "code": "4",
        "name": "국민은행"
    },
    {
        "code": "99",
        "name": "금융결제원"
    },
    {
        "code": "77",
        "name": "기술보증기금"
    },
    {
        "code": "3",
        "name": "기업은행"
    },
    {
        "code": "11",
        "name": "농협은행"
    },
    {
        "code": "31",
        "name": "대구은행"
    },
    {
        "code": "102",
        "name": "대신저축은행"
    },
    {
        "code": "267",
        "name": "대신증권"
    },
    {
        "code": "238",
        "name": "대우증권"
    },
    {
        "code": "65",
        "name": "대화은행"
    },
    {
        "code": "55",
        "name": "도이치은행"
    },
    {
        "code": "223",
        "name": "리딩투자증권"
    },
    {
        "code": "287",
        "name": "메리츠종합금융증권"
    },
    {
        "code": "52",
        "name": "모건스탠리은행"
    },
    {
        "code": "230",
        "name": "미래에셋증권"
    },
    {
        "code": "59",
        "name": "미쓰비시도쿄UFJ은행"
    },
    {
        "code": "58",
        "name": "미즈호은행"
    },
    {
        "code": "290",
        "name": "부국증권"
    },
    {
        "code": "32",
        "name": "부산은행"
    },
    {
        "code": "61",
        "name": "비엔피파리바은행"
    },
    {
        "code": "64",
        "name": "산림조합중앙회"
    },
    {
        "code": "2",
        "name": "산업은행"
    },
    {
        "code": "296",
        "name": "삼성선물"
    },
    {
        "code": "240",
        "name": "삼성증권"
    },
    {
        "code": "50",
        "name": "상호저축은행"
    },
    {
        "code": "45",
        "name": "새마을금고중앙회"
    },
    {
        "code": "94",
        "name": "서울보증보험"
    },
    {
        "code": "8",
        "name": "수출입은행"
    },
    {
        "code": "7",
        "name": "수협중앙회"
    },
    {
        "code": "291",
        "name": "신영증권"
    },
    {
        "code": "76",
        "name": "신용보증기금"
    },
    {
        "code": "278",
        "name": "신한금융투자"
    },
    {
        "code": "88",
        "name": "신한은행"
    },
    {
        "code": "106",
        "name": "신한저축은행"
    },
    {
        "code": "48",
        "name": "신협중앙회"
    },
    {
        "code": "56",
        "name": "알비에스피엘씨은행"
    },
    {
        "code": "103",
        "name": "에스비아이저축은행"
    },
    {
        "code": "104",
        "name": "에이치케이저축은행"
    },
    {
        "code": "292",
        "name": "엘아이지투자증권"
    },
    {
        "code": "297",
        "name": "외환선물"
    },
    {
        "code": "5",
        "name": "외환은행"
    },
    {
        "code": "20",
        "name": "우리은행"
    },
    {
        "code": "295",
        "name": "우리종합금융"
    },
    {
        "code": "71",
        "name": "우체국"
    },
    {
        "code": "105",
        "name": "웰컴저축은행"
    },
    {
        "code": "209",
        "name": "유안타증권"
    },
    {
        "code": "280",
        "name": "유진투자증권"
    },
    {
        "code": "265",
        "name": "이베스트투자증권"
    },
    {
        "code": "37",
        "name": "전북은행"
    },
    {
        "code": "57",
        "name": "제이피모간체이스은행"
    },
    {
        "code": "35",
        "name": "제주은행"
    },
    {
        "code": "62",
        "name": "중국공상은행"
    },
    {
        "code": "51",
        "name": "중국은행"
    },
    {
        "code": "63",
        "name": "중국은행"
    },
    {
        "code": "12",
        "name": "지역농.축협"
    },
    {
        "code": "90",
        "name": "카카오뱅크"
    },
    {
        "code": "288",
        "name": "카카오페이증권"
    },
    {
        "code": "89",
        "name": "케이뱅크"
    },
    {
        "code": "264",
        "name": "키움증권"
    },
    {
        "code": "92",
        "name": "토스뱅크"
    },
    {
        "code": "294",
        "name": "펀드온라인코리아"
    },
    {
        "code": "270",
        "name": "하나대투증권"
    },
    {
        "code": "262",
        "name": "하이투자증권"
    },
    {
        "code": "27",
        "name": "한국씨티은행"
    },
    {
        "code": "1",
        "name": "한국은행"
    },
    {
        "code": "96",
        "name": "한국전자금융(주)"
    },
    {
        "code": "93",
        "name": "한국주택금융공사"
    },
    {
        "code": "293",
        "name": "한국증권금융"
    },
    {
        "code": "243",
        "name": "한국투자증권"
    },
    {
        "code": "222",
        "name": "한양증권"
    },
    {
        "code": "269",
        "name": "한화투자증권"
    },
    {
        "code": "298",
        "name": "현대선물"
    },
    {
        "code": "218",
        "name": "현대증권"
    },
]

export default bank;